import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectVirtualSwitchActionState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/VirtualSwitchAction/SelectVirtualSwitchActionState/SelectVirtualSwitchActionState'
import SelectVirtualSwitchActionStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/VirtualSwitchAction/SelectVirtualSwitchActionState/SelectVirtualSwitchActionState'
import {
  saveActionDeviceStateInfo,
  saveActionType,
  saveActionStateDescription,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveInitialActionInfo,
} from '@app/actions/scenes/currentSceneCreating'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectVirtualSwitchActionStateIOS) : withStyles(SelectVirtualSwitchActionState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    stateDescription,
    actionDeviceNumber,
    delay: actionDelay,
    delayDescription,
    durationDescription,
    durationValueAfter,
    duration: actionDuration,
  } = state.scenes.currentSceneCreating.currentAction
  const { isEditActionMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    stateDescription,
    isEditActionMode,
    actionDeviceNumber,
    actionDelay,
    delayDescription,
    durationDescription,
    durationValueAfter,
    actionDuration,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveInitialActionInfo,
  saveActionDeviceStateInfo,
  saveActionType,
  saveActionStateDescription,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectVirtualSwitchActionStateEnhanced = enhance

export default withRouter(SelectVirtualSwitchActionStateEnhanced)
